import Vue from 'vue'

const TAGCATEGORY_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};


const TAGCATEGORY_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};

const TAGCATEGORY_SET_TAGCATEGORIES =(state, payload)=> {  
    
    state.tagcategories=payload
    
};

const TAGCATEGORY_SET_TAGCATEGORY =(state, payload)=> {       
    
    state.data.name = payload.name
        
};

const TAGCATEGORY_INIT_TAGCATEGORY =(state, payload)=> {       
    state.data.name = ''    
    
};



export default {
    TAGCATEGORY_SET_NAME,
    TAGCATEGORY_SET_DUPLICATE,
    TAGCATEGORY_SET_TAGCATEGORIES,
    TAGCATEGORY_SET_TAGCATEGORY,
    TAGCATEGORY_INIT_TAGCATEGORY,
};